// Canonical source for the generic NHS surgical preparation checklist.
// Language drafts live in hospitalJourney.ui.preparationChecklist and
// require human clinical and linguistic review before patient-facing release.
export const PREPARATION_CHECKLIST_ENGLISH = Object.freeze({
  title: 'My Preparation Checklist',
  ariaLabel: 'My preparation checklist',
  intro: 'Check what you understand. If you are unsure, choose I need to ask. Your answers stay on this device and are not sent to your hospital.',
  clear: 'Clear answer',
  safety: 'This is an understanding check, not medical clearance. Always follow the instructions from your own hospital team. Do not change medicines or fasting plans based on this checklist.',
  summaryTitle: 'My Preparation Checklist: review',
  askHeading: 'Things to ask your hospital team',
  reviewed: 'You have reviewed all the questions. This does not confirm you are ready or fit for surgery.',
  contact: "This checklist does not contact your hospital. If you have unanswered questions or concerns, contact your pre-assessment or surgical team using your hospital's contact details.",
  progress: 'Your answers are saved only on this device.',
  answeredLabel: 'Questions answered',
  unanswered: 'There are questions you have not answered. You can return to the checklist above at any time.',
  responses: {
    checked: "I've checked this",
    ask: 'I need to ask',
    notApplicable: 'Not applicable',
  },
  items: {
    fasting: 'I know where to find my own instructions about when to stop eating and drinking.',
    medicines: 'I have checked what my hospital has told me about my usual medicines before surgery.',
    arrivalDay: 'I know where to go and what time to arrive.',
    arrivalInpatient: 'I know where to go and what time to arrive for my admission.',
    transport: 'I know how I will get to hospital and whether I need to ask about hospital transport.',
    homeSupport: 'I know who to ask if I am worried about getting home or having support after surgery.',
    dischargeSupport: 'I know who to ask about any support I may need when I leave hospital.',
    aftercareContact: "I know where to find my hospital team's advice about who to contact after I go home.",
  },
});
